// @ts-nocheck
import $ from 'jquery';

export const STORAGE_KEY = 'partnerAppStatus';
const CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes
const cache = {};

// Seed in-memory cache from localStorage so the first read is instant.
try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    const now = Date.now();
    for (const [id, entry] of Object.entries(stored)) {
        if (entry && entry._cachedAt && now - entry._cachedAt < CACHE_TTL_MS) {
            cache[id] = entry;
        }
    }
} catch {
    /* private browsing / corrupt data – ignore */
}

function persistCache() {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
    } catch {
        /* quota exceeded – ignore */
    }
}

/**
 * Fetches (and caches) the partner-app-status for a partner from the API.
 * Returns a Promise that resolves to the full status object.
 */
export function fetchPartnerAppStatus(partnerId) {
    if (cache[partnerId] !== undefined) {
        return Promise.resolve(cache[partnerId]);
    }

    return new Promise(resolve => {
        $.ajax({
            url: `/api/v1/partners/${partnerId}/partner-app-status`,
            type: 'GET',
            dataType: 'json',
            success(data) {
                cache[partnerId] = {
                    hasApp: data.has_app === true,
                    appCoreVersion: data.app_core_version || null,
                    appIsActive: data.app_is_active ?? null,
                    firebaseFcm: data.firebase_fcm === true,
                    pushProvider: data.push_provider || '',
                    pushTopic: data.push_topic || '',
                    pushMessages: data.push_messages === true,
                    pushMessagesScheduled: data.push_messages_scheduled === true,
                    _cachedAt: Date.now(),
                };
                persistCache();
                resolve(cache[partnerId]);
            },
            error() {
                cache[partnerId] = {
                    hasApp: false,
                    appCoreVersion: null,
                    appIsActive: null,
                    firebaseFcm: false,
                    pushProvider: '',
                    pushTopic: '',
                    pushMessages: false,
                    pushMessagesScheduled: false,
                };
                resolve(cache[partnerId]);
            },
        });
    });
}

/**
 * Kick off the API fetch early so the result is cached before any
 * component mounts.  Safe to call before jQuery ajaxSend hooks are
 * wired – the cache seed from localStorage covers the gap.
 */
export function preloadPartnerAppStatus(partnerId) {
    if (partnerId) {
        fetchPartnerAppStatus(partnerId);
    }
}
